import React, { Component } from "react";
import { Container, Alert } from "reactstrap";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import FormBuilder from "../../../toolkit/baseForms2/formBuilder/FormBuilder";
import { Inputs, Buttons, formConfig } from "./BajaApp.form";
import ConfirmModal from "../common/confirmModal/confirmModal";
import {
  errorNotification,
  successNotification
} from "../../../utils/notifications";
import { Preview } from "../../../types/IAction";
import s from "./styles.scss";

interface Props {
  bajaAppResult: any;
  postingBajaApp: boolean;
  postingBajaAppError: string;
  userId?: number | string;
  deleteBajaAppTotalPass: (
    idPersona: number | string,
    userId?: number | string
  ) => Promise<Preview<any>>;
}

interface State {
  confirmOpen: boolean;
  idPersona: string;
}

const MENSAJE_SOLO_NUMERICO = "Solo se permite numérico";

/**
 * Baja de app TotalPass — UI
 * Pantalla: /total-pass/baja-app
 *
 * BFF: DELETE /api/total-pass/personas/{idPersona}/baja-app?userId={userId}
 */
class BajaAppComponent extends Component<Props, State> {
  state = {
    confirmOpen: false,
    idPersona: ""
  };

  submit = (data: { [key in Inputs]: any }) => {
    const idPersona =
      data.idPersona != null ? String(data.idPersona).trim() : "";
    if (!idPersona) {
      errorNotification("El Id Persona es obligatorio");
      return;
    }
    if (!/^\d+$/.test(idPersona)) {
      errorNotification(MENSAJE_SOLO_NUMERICO);
      return;
    }
    this.setState({ confirmOpen: true, idPersona });
  };

  procesar = async () => {
    const { idPersona } = this.state;
    this.setState({ confirmOpen: false });

    const preview = await this.props.deleteBajaAppTotalPass(
      idPersona,
      this.props.userId
    );
    if (!preview.fulfilled) {
      errorNotification(
        preview.postingBajaAppError || "No fue posible procesar la baja de app"
      );
      return;
    }

    const result = preview.bajaAppResult;
    const msg =
      (result && result.message) || "Baja de app procesada correctamente";
    successNotification(msg);
  };

  render() {
    const { postingBajaApp, bajaAppResult, postingBajaAppError } = this.props;
    const success = bajaAppResult && bajaAppResult.success !== false;

    return (
      <Container className="mt-3 mb-5">
        <div className={s.filtros}>
          <FormBuilder<Inputs, Buttons>
            config={formConfig}
            submit={this.submit}
            processing={postingBajaApp}
          />
        </div>

        {(bajaAppResult || postingBajaAppError) && (
          <div className={s.resultado}>
            <div className={s.resultadoTitulo}>Resultado</div>
            {postingBajaAppError ? (
              <Alert color="danger" className={s.error}>
                {postingBajaAppError}
              </Alert>
            ) : (
              <Alert color={success ? "success" : "warning"}>
                <div className={success ? s.ok : s.error}>
                  {(bajaAppResult && bajaAppResult.message) ||
                    "Operación completada"}
                </div>
                {bajaAppResult && bajaAppResult.status != null && (
                  <div>Status: {bajaAppResult.status}</div>
                )}
              </Alert>
            )}
          </div>
        )}

        <ConfirmModal
          title="Confirmar baja de app"
          message={`Se procesará la baja de app TotalPass para el idPersona ${this.state.idPersona}. ¿Desea continuar?`}
          isOpen={this.state.confirmOpen}
          size="md"
          waiting={postingBajaApp}
          ok={this.procesar}
          cancel={() => this.setState({ confirmOpen: false })}
        />
      </Container>
    );
  }
}

export default withStyles(s)(BajaAppComponent);
